import Overlay from './src/overlay'

export const VsOverlay = Overlay
export default VsOverlay

export * from './src/overlay'
